import { Mark, Tip } from "./OriginMark";

// Third-party job boards a tracked company can be pulled from. Keys match the
// scout worker / BFF (`platform` on job rows, `platforms.<key>` on tracked rows).
export const PLATFORMS = {
  linkedin: { label: "LinkedIn" },
  efc: { label: "eFinancialCareers" },
  jobsdb: { label: "JobsDB" },
};

// Simplified brand-neutral tiles drawn inline — nothing is fetched.
const TILE_FONT = "Arial, Helvetica, sans-serif";
const TILES = {
  linkedin: { fill: "#0A66C2", text: "in", fontSize: 13.5, y: 17, textLength: null },
  efc: { fill: "#2B3A67", text: "eFC", fontSize: 9.5, y: 15.5, textLength: 19 },
  jobsdb: { fill: "#1C4FB8", text: "jobsDB", fontSize: 6.5, y: 14.5, textLength: 20 },
};

// The tile at any size; renders nothing for an unknown platform.
export function PlatformLogo({ platform, size = 16, style }) {
  const t = TILES[platform];
  if (!t) return null;
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      aria-hidden="true"
      style={{ display: "block", flexShrink: 0, ...style }}
    >
      <rect width="24" height="24" rx="5" fill={t.fill} />
      <text
        x="12"
        y={t.y}
        textAnchor="middle"
        fontFamily={TILE_FONT}
        fontWeight="700"
        fontSize={t.fontSize}
        fill="#fff"
        textLength={t.textLength || undefined}
        lengthAdjust={t.textLength ? "spacingAndGlyphs" : undefined}
      >
        {t.text}
      </text>
    </svg>
  );
}

// Small mark with a "From LinkedIn" tooltip, for job cards. Same look as OriginMark.
export default function PlatformMark({ platform, size = 14 }) {
  const p = PLATFORMS[platform];
  if (!p) return null;
  const label = `From ${p.label}`;
  return (
    <Mark $size={size} aria-label={label} role="img" tabIndex={0}>
      <PlatformLogo platform={platform} size={size} />
      <Tip aria-hidden="true">{label}</Tip>
    </Mark>
  );
}
